module.exports = __webpack_public_path__ + "static/media/olake-product-1.f4b6507e.svg";